(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const menuSelector = '[data-product-mega-menu]';
    const tabSelector = '[data-product-mega-tab]';
    const panelSelector = '[data-product-mega-panel]';
    const leftHeaderSelector = '[data-site-header][data-nav-alignment="left"]';

    const updateNavLeftCompression = () => {
      if (window.matchMedia('(pointer: coarse)').matches) return;

      document.querySelectorAll(leftHeaderSelector).forEach((header) => {
        const nav = header.querySelector('[data-nav]');
        const logo = header.querySelector('[data-logo]');
        const links = nav && (nav.querySelector(':scope > .menu__items') || nav.querySelector('.menu__items'));
        const icons = header.querySelector('[data-nav-icons]');

        if (!nav || !logo || !links || !icons) return;

        header.classList.remove('site-header--compress');

        const logoWidth = Math.ceil(logo.getBoundingClientRect().width);
        const linksWidth = Math.ceil(links.scrollWidth);
        const iconsWidth = Math.ceil(icons.getBoundingClientRect().width);
        const safeGap = 40;
        const requiredWidth = Math.max(linksWidth, iconsWidth) * 2 + logoWidth + safeGap;

        header.classList.toggle('site-header--compress', window.innerWidth < requiredWidth);
      });
    };

    const scheduleNavLeftCompression = () => {
      requestAnimationFrame(updateNavLeftCompression);
    };

    const updateIndicator = (menu, tab) => {
      const tabs = menu.querySelector('[data-product-mega-tabs]');
      if (!tabs || !tab) return;

      const tabsRect = tabs.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();
      const left = tabRect.left - tabsRect.left + tabs.scrollLeft;

      tabs.style.setProperty('--product-mega-indicator-left', `${left}px`);
      tabs.style.setProperty('--product-mega-indicator-width', `${tabRect.width}px`);
      tabs.style.setProperty('--product-mega-indicator-opacity', '1');
    };

    const activateTab = (menu, tab) => {
      if (!menu || !tab || tab.classList.contains('is-current')) return;

      const target = tab.getAttribute('data-product-mega-tab');

      menu.querySelectorAll(tabSelector).forEach((item) => {
        const isCurrent = item === tab;
        item.classList.toggle('is-current', isCurrent);
        item.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
      });

      menu.querySelectorAll(panelSelector).forEach((panel) => {
        const isCurrent = panel.getAttribute('data-product-mega-panel') === target;
        panel.classList.toggle('is-current', isCurrent);
        panel.hidden = !isCurrent;
      });

      updateIndicator(menu, tab);
      document.dispatchEvent(new CustomEvent('theme:resize', {bubbles: true}));
    };

    const initMenu = (menu) => {
      if (menu.hasAttribute('data-product-mega-menu-ready')) return;
      menu.setAttribute('data-product-mega-menu-ready', 'true');

      const currentTab = menu.querySelector(`${tabSelector}.is-current`) || menu.querySelector(tabSelector);
      if (currentTab) {
        requestAnimationFrame(() => updateIndicator(menu, currentTab));
      }
    };

    const initMenus = (root = document) => {
      root.querySelectorAll(menuSelector).forEach(initMenu);
    };

    document.addEventListener('click', (event) => {
      const tab = event.target.closest(tabSelector);
      if (!tab) return;
      activateTab(tab.closest(menuSelector), tab);
    });

    document.addEventListener('mouseover', (event) => {
      const tab = event.target.closest(tabSelector);
      if (!tab) return;
      activateTab(tab.closest(menuSelector), tab);
    });

    document.addEventListener('focusin', (event) => {
      const tab = event.target.closest(tabSelector);
      if (!tab) return;
      activateTab(tab.closest(menuSelector), tab);
    });

    document.addEventListener('DOMContentLoaded', () => {
      initMenus();
      scheduleNavLeftCompression();
    });
    window.addEventListener('load', scheduleNavLeftCompression);
    window.addEventListener('resize', scheduleNavLeftCompression);
    document.addEventListener('shopify:section:load', (event) => {
      initMenus(event.target);
      scheduleNavLeftCompression();
    });
    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest(panelSelector);
      if (!panel) return;

      const menu = panel.closest(menuSelector);
      if (!menu) return;

      const tab = menu.querySelector(`${tabSelector}[data-product-mega-tab="${panel.getAttribute('data-product-mega-panel')}"]`);
      if (tab) activateTab(menu, tab);
    });
    document.addEventListener('theme:resize', () => {
      document.querySelectorAll(menuSelector).forEach((menu) => {
        updateIndicator(menu, menu.querySelector(`${tabSelector}.is-current`));
      });
      scheduleNavLeftCompression();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-flow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.themeFlowSection) {
      window.themeFlowSection.init();
      return;
    }

    const instances = new Map();

    class FlowSection {
      constructor(section) {
        this.section = section;
        this.id = section.getAttribute('data-section-id');
        this.items = [...section.querySelectorAll('[data-flow-item]')];
        this.triggers = [...section.querySelectorAll('[data-flow-trigger]')];
        this.panels = [...section.querySelectorAll('[data-flow-panel]')];
        this.media = [...section.querySelectorAll('[data-flow-media]')];
        this.interaction = section.getAttribute('data-flow-interaction');
        this.autoplay = section.getAttribute('data-flow-autoplay') === 'true';
        this.pauseHover = section.getAttribute('data-flow-pause-hover') === 'true';
        this.interval = Number(section.getAttribute('data-flow-interval')) || 5000;
        this.openFirst = section.getAttribute('data-flow-open-first') === 'true';
        this.activeIndex = 0;
        this.timer = null;
        this.controller = new AbortController();

        if (this.triggers.length === 0) return;

        this.bind();
        this.setActive(0, this.openFirst);
        this.start();
      }

      bind() {
        this.triggers.forEach((trigger) => {
          const index = Number(trigger.getAttribute('data-index'));

          trigger.addEventListener('click', () => {
            this.setActive(index, true);
            this.restart();
          }, {signal: this.controller.signal});

          if (this.interaction === 'hover') {
            trigger.addEventListener('mouseenter', () => {
              this.setActive(index, true);
              this.restart();
            }, {signal: this.controller.signal});
          }
        });

        this.section.addEventListener('focusin', () => this.pause(), {signal: this.controller.signal});
        this.section.addEventListener('focusout', () => this.start(), {signal: this.controller.signal});

        if (this.pauseHover) {
          this.section.addEventListener('mouseenter', () => this.pause(), {signal: this.controller.signal});
          this.section.addEventListener('mouseleave', () => this.start(), {signal: this.controller.signal});
        }
      }

      setActive(index, open = true) {
        this.activeIndex = index;

        this.items.forEach((item) => {
          item.classList.toggle('is-active', Number(item.getAttribute('data-index')) === index);
        });

        this.triggers.forEach((trigger) => {
          const isActive = Number(trigger.getAttribute('data-index')) === index;
          trigger.setAttribute('aria-expanded', isActive && open ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const isActive = Number(panel.getAttribute('data-index')) === index;
          panel.hidden = !(isActive && open);
        });

        this.media.forEach((media) => {
          const isActive = Number(media.getAttribute('data-index')) === index;
          media.classList.toggle('is-active', isActive);
          media.hidden = !isActive;

          media.querySelectorAll('video').forEach((video) => {
            if (isActive && video.hasAttribute('autoplay')) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      }

      start() {
        if (!this.autoplay || this.triggers.length < 2 || this.timer) return;

        this.timer = window.setInterval(() => {
          const nextIndex = this.activeIndex + 1 >= this.triggers.length ? 0 : this.activeIndex + 1;
          this.setActive(nextIndex, true);
        }, this.interval);
      }

      pause() {
        if (!this.timer) return;

        window.clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.pause();
        this.start();
      }

      destroy() {
        this.pause();
        this.controller.abort();
      }
    }

    const init = (root = document) => {
      root.querySelectorAll('[data-flow-section]').forEach((section) => {
        const id = section.getAttribute('data-section-id');

        if (!instances.has(id)) {
          instances.set(id, new FlowSection(section));
        }
      });
    };

    const unload = (sectionId) => {
      const instance = instances.get(sectionId);

      if (!instance) return;

      instance.destroy();
      instances.delete(sectionId);
    };

    window.themeFlowSection = {init, unload, instances};

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));

    document.addEventListener('shopify:section:unload', (event) => {
      unload(event.detail.sectionId);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const block = event.target.closest('[data-flow-block]');
      const section = block && block.closest('[data-flow-section]');
      if (!block || !section) return;

      const instance = instances.get(section.getAttribute('data-section-id'));
      if (!instance) return;

      instance.setActive(Number(block.getAttribute('data-index')), true);
      instance.pause();
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const block = event.target.closest('[data-flow-block]');
      const section = block && block.closest('[data-flow-section]');
      if (!block || !section) return;

      const instance = instances.get(section.getAttribute('data-section-id'));
      if (instance) instance.start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-social-proof-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSocialProofTabs = (root = document) => {
      root.querySelectorAll('[data-social-proof-tabs]').forEach((tabs) => {
        if (tabs.dataset.tabsReady === 'true') return;

        const buttons = [...tabs.querySelectorAll('[data-social-proof-tab]')];
        const panels = [...tabs.querySelectorAll('[data-social-proof-panel]')];

        const activate = (target) => {
          buttons.forEach((button) => {
            const isActive = button.dataset.socialProofTab === target;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const isActive = panel.dataset.socialProofPanel === target;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => activate(button.dataset.socialProofTab));
        });

        tabs.dataset.tabsReady = 'true';
      });
    };

    document.addEventListener('DOMContentLoaded', () => initSocialProofTabs());
    document.addEventListener('shopify:section:load', (event) => initSocialProofTabs(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
